/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_ResendInputs */

const en_signin_resend = /** @type {(inputs: Signin_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

const id_signin_resend = /** @type {(inputs: Signin_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim ulang kode`)
};

/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Signin_ResendInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_resend = /** @type {((inputs?: Signin_ResendInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_ResendInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_resend(inputs)
	return en_signin_resend(inputs)
});